
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class ItirazBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "ItirazBasvuruSave";
    super(baseUrl);
  }


  saveItirazBasvuruSave(request: ItirazBasvuruSaveRequest){
    
    return this.post("", request, false);
   
  }

}
export default new ItirazBasvuruAPI();

class ItirazBasvuruSaveRequest {
    basvuruTuruId: number;
    faturaSqId: number;
    aciklama?: string;
    captchaToken?: string;

    constructor(basvuruTuruId: number, faturaSqId: number, aciklama?: string, captchaToken?: string) {
        this.basvuruTuruId = basvuruTuruId;
        this.faturaSqId = faturaSqId;
        this.aciklama = aciklama;
        this.captchaToken = captchaToken;
    }
}
export { ItirazBasvuruSaveRequest };